import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
export const ToolSemanticLogPanel = ({ text, entryCount, className, }) => {
    const [copyState, setCopyState] = React.useState("idle");
    const handleCopy = React.useCallback(async () => {
        try {
            if (!navigator.clipboard || typeof navigator.clipboard.writeText !== "function") {
                throw new Error("Clipboard API unavailable");
            }
            await navigator.clipboard.writeText(text);
            setCopyState("copied");
            window.setTimeout(() => setCopyState("idle"), 1400);
        }
        catch {
            setCopyState("failed");
            window.setTimeout(() => setCopyState("idle"), 1800);
        }
    }, [text]);
    return (_jsxs("div", { className: className ?? "w-full py-[1px]", children: [_jsxs("div", { className: "flex items-center justify-between gap-2 pb-[4px]", children: [_jsxs("p", { className: "text-[10px] leading-[1.5] font-bold text-gray-700", children: ["Execution Log", typeof entryCount === "number" && entryCount > 0 ? ` (${entryCount})` : ""] }), _jsx("button", { type: "button", onClick: () => {
                            void handleCopy();
                        }, className: `rounded border px-2 py-[1px] text-[10px] leading-[1.4] ${copyState === "copied"
                            ? "border-green-300 text-green-700 bg-green-50"
                            : copyState === "failed"
                                ? "border-red-300 text-red-700 bg-red-50"
                                : "border-gray-300 text-gray-700 hover:bg-gray-200"}`, "aria-label": "Copy execution log", children: copyState === "copied" ? "Copied" : copyState === "failed" ? "Copy failed" : "Copy" })] }), _jsx("pre", { className: "w-full max-h-52 overflow-auto whitespace-pre-wrap break-words rounded border border-gray-300 bg-white px-2 py-[6px] text-[10px] leading-[1.45] text-gray-800", children: text })] }));
};
